import { RecruitmentStatus } from './recruitment.model';

export const RECRUITMENT_STATUS_OPTIONS: { value: RecruitmentStatus; label: string }[] = [
  { value: 'SCHEDULED', label: 'Scheduled' },
  { value: 'RESCHEDULED', label: 'Re-Scheduled' },
  { value: 'CANCELLED', label: 'Cancelled' },
  { value: 'INTERVIEWED', label: 'Interviewed' },
  { value: 'ON_HOLD', label: 'On Hold' },
  { value: 'SCREEN_PAST', label: 'Screen Past' },
  { value: 'PASS_CLEARED', label: 'Pass/Cleared' },
  { value: 'SELECTED', label: 'Selected' },
  { value: 'OFFERED', label: 'Offered' },
  { value: 'REJECTED', label: 'Rejected' }
];

export const PRE_OFFER_STATUS_OPTIONS: { value: RecruitmentStatus; label: string }[] = [
  { value: 'SCHEDULED', label: 'Scheduled' },
  { value: 'RESCHEDULED', label: 'Re-Scheduled' },
  { value: 'CANCELLED', label: 'Cancelled' },
  { value: 'SCREEN_PAST', label: 'Screen Past' },
  { value: 'SELECTED', label: 'Selected' },
  { value: 'OFFERED', label: 'Offered' },
  { value: 'REJECTED', label: 'Rejected' }
];

export const INTERVIEWER_STATUS_OPTIONS: { value: RecruitmentStatus; label: string }[] = [
  { value: 'ON_HOLD', label: 'On Hold' },
  { value: 'PASS_CLEARED', label: 'Pass/Cleared' },
  { value: 'REJECTED', label: 'Rejected' }
];

export const POST_OFFER_STATUS_OPTIONS: { value: RecruitmentStatus; label: string }[] = [
  { value: 'MSA_SENT', label: 'MSA Sent' },
  { value: 'MSA_ACCEPTED', label: 'MSA Accepted' },
  { value: 'JOINED', label: 'Joined' },
  { value: 'REJECTED', label: 'Rejected' }
];

export const INTERVIEW_ROUND_OPTIONS = [
  'Screening',
  'Round 1',
  'Round 2',
  'Round 3',
  'Final Interaction',
  'HR Round'
];

export const STATUS_ORDER: Record<RecruitmentStatus, number> = {
  PENDING: 0,
  SCHEDULED: 1,
  RESCHEDULED: 1,
  CANCELLED: 1,
  INTERVIEWED: 2,
  ON_HOLD: 3,
  SCREEN_PAST: 4,
  PASS_CLEARED: 4,
  SELECTED: 5,
  OFFERED: 6,
  MSA_SENT: 7,
  MSA_ACCEPTED: 8,
  JOINED: 9,
  REJECTED: 99
};

export const INTERVIEW_ROUND_ORDER: Record<string, number> = {
  'Screening': 1,
  'Round 1': 2,
  'Round 2': 3,
  'Round 3': 4,
  'Final Interaction': 5,
  'HR Round': 6
};

export const RECOMMENDATION_STATUS_OPTIONS = [
  { value: 'RECOMMENDED', label: 'Recommended' },
  { value: 'NOT_RECOMMENDED', label: 'Not Recommended' },
  { value: 'ON_HOLD', label: 'On Hold' }
];

export const DEFAULT_SELECTION_PERCENTAGE = 60;

export const RECRUITMENT_MESSAGES = {
  statusBackward: 'Candidate status cannot be moved back to an earlier stage.',
  rejectedLocked: 'Rejected candidate status cannot be changed.',
  acceptedLocked: 'MSA accepted candidate status cannot be changed.',
  joinedLocked: 'Joined candidate status cannot be changed.',
  interviewRoundBackward: 'Interview round cannot be moved back to an earlier round.',
  recommendationRequired: 'Recommendation is required.',
  remarksRequired: 'Remarks are required.'
};

export interface RecruitmentDocumentApi {
  id: number;
  fileName: string;
  storageUrl: string;
}

export interface RecruitmentCandidateApi {
  id: number;
  fullName: string;
  email: string;
  contactNumber: string;
  totalExperience: string;
  status: RecruitmentStatus;
  reviewed: boolean;
  reviewedBy: string;
  sourceOfResume: string;
  // need to check once 
  departmentId?: number | string;
  departmentID?: number | string;
  department_id?: number | string;
  deptId?: number | string;
  departmentName?: string;
  department?: string;
  // about department
  cvUploadedOn: string;
  reviewedOn: string;
  interviewScheduledOn?: string;
  scheduledOn?: string;
  interviewerName: string;
  interviewRound: string;
  technicalSkills: string;
  overallPercentage: number | null;
  recommendationStatus: string;
  interviewTakenTime: string;
  currentCompany: string;
  skills: string;
  techStack: string;
  education: string;
  remarks: string;
  createdDate?: string;
  createdAt?: string;
  createDate?: string;
  created_date?: string;
  created_on?: string;
  uploadedOn?: string;
  parsedOn?: string;
  resumeUploadedOn?: string;
  sourceResumeFileName: string;
  documents: RecruitmentDocumentApi[];
}

  export interface RecruitmentCandidateListApi {
  responseData: RecruitmentCandidateApi[];
  totalRecords: number;
}

export interface RecruitmentStats {
  totalCandidates: number;
  reviewed: number;
  interviewed: number;
  offered: number;
  rejected: number;
}